import React from 'react';

import { useLocale } from 'src/modules/locale';
import { ArticlesDetailsContent } from 'src/modules/articles';
import { useIntl } from 'react-intl';
import { ArticleEntity } from 'src/modules/articles';

interface ArticlesDetailsPageProps {
  magazinePage: {
    article: ArticleEntity;
    relatedArticles: ArticleEntity[];
  };
}

const ArticlesDetailsPage: React.FunctionComponent<ArticlesDetailsPageProps> = (props) => {
  const { getLocalizedObject } = useLocale();
  const intl = useIntl();

  if (!props?.magazinePage) return null;

  const { article, relatedArticles } = getLocalizedObject(props.magazinePage);

  const breadcrumbs = [
    {
      title: intl.formatMessage({ id: 'breadcrumbs/magazine' }),
      href: '/magazine',
      as: '/magazine',
    },
    {
      title: article?.hero?.title,
      href: '/magazine/[slug]',
      as: `/magazine/${encodeURIComponent(article?.slug)}`,
    },
  ];

  const products = article?.products?.length || article?.reference?.products || null;
  return (
    <ArticlesDetailsContent
      article={article}
      relatedArticles={relatedArticles}
      breadcrumbs={breadcrumbs}
      products={products}
      // relatedArticlesHeadingTitle="page/magazine/details/related_articles"
    />
  );
};

export default ArticlesDetailsPage;
